import t from "../../../helpers/t";
import React from "react";

const HelpMessageItemsPanel = (props) => {
    const {helpMessage} = props;
    return(
        <>

            <div className={"inb-contingent-progress"}
                 style={{marginBottom: "-1rem"}}>
                    <>
                        <div className="progress beautify" role="progressbar" tabIndex="0"
                             aria-valuenow="50" aria-valuemin="0" aria-valuetext="50 percent" aria-valuemax="100">
                        <div className="progress-bars">
                            {/*<span className="progress-meter" style={{width: "100%"}}> </span>*/}
                        </div>
                        <p className="progress-meter-text">
                            {typeof helpMessage.help_message_items !== 'undefined' ?helpMessage.help_message_items.length:0 + ' ' + t('help message items',null,'capital') }
                        </p>
                        </div>
                    </>
                </div>
        </>
    )
}
export default HelpMessageItemsPanel;